// import gallery2 from "./assets/gallery/1.png";
import gallery1 from "./assets/gallery/2.png";
import gallery3 from "./assets/gallery/3.png";
import gallery4 from "./assets/gallery/4.JPG";
import gallery5 from "./assets/gallery/5.JPG";
import gallery6 from "./assets/gallery/6.JPG";
import gallery7 from "./assets/gallery/7.JPG";
import gallery9 from "./assets/gallery/9.JPG";
import gallery8 from "./assets/gallery/8.JPG";

// galleryImages.js

import img1 from "./assets/gallery/20.jpg";
import img2 from "./assets/gallery/21.jpg";
import img3 from "./assets/gallery/22.jpg";
import img4 from "./assets/gallery/23.jpg";
import img5 from "./assets/gallery/24.jpg";
import img6 from "./assets/gallery/25.jpg";
import img7 from "./assets/gallery/26.jpg";
import img8 from "./assets/gallery/27.jpg";
import img9 from "./assets/gallery/28.jpg";
import img10 from "./assets/gallery/29.jpg";
import img11 from "./assets/gallery/30.jpg";
import img12 from "./assets/gallery/31.jpg";
import img13 from "./assets/gallery/32.jpg";
import img14 from "./assets/gallery/33.jpg";
import img15 from "./assets/gallery/34.jpg";
import img16 from "./assets/gallery/35.jpg";
import img17 from "./assets/gallery/36.jpg";
import img18 from "./assets/gallery/37.jpg";
import img19 from "./assets/gallery/38.jpg";
import img20 from "./assets/gallery/39.jpg";

export const mainGalleryImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
];

export const galleryImages = [
  img7,
  gallery4,
  gallery5,
  img14,
  img7,
  gallery8,
  gallery9,
  img12,
  img18,
  //   gallery10,
  //   gallery11,
  //   gallery12,
  //   gallery13,
  //   gallery14,
  //   gallery15,
  //   gallery16,
  //   gallery2,
  //   gallery17,
  //   gallery18,
  //   gallery19,
  //   gallery20,
  //   gallery21,
  //   gallery22,
  //   gallery23,
];
